interface Props {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  onChange: (value: string) => void;
}

export default function OptionToggle({ label, value, options, onChange }: Props) {
  return <div className="option-toggle" role="group" aria-label={label}>
    {options.map(option => <button key={option.value} type="button" value={option.value}
      aria-pressed={value === option.value} onClick={() => onChange(option.value)}>
      {option.label}
    </button>)}
  </div>;
}
